__turbopack_context__.v({
  "container": "VideoBlock-module-scss-module__lB31ua__container",
  "embedFill": "VideoBlock-module-scss-module__lB31ua__embedFill",
  "frame": "VideoBlock-module-scss-module__lB31ua__frame",
  "iframeWrapper": "VideoBlock-module-scss-module__lB31ua__iframeWrapper",
  "playButton": "VideoBlock-module-scss-module__lB31ua__playButton",
  "poster": "VideoBlock-module-scss-module__lB31ua__poster",
  "posterImage": "VideoBlock-module-scss-module__lB31ua__posterImage",
});
